export enum PermissionEnum {

  //Roles
  AddRole = "add.role",
  DeleteRole = "delete.role",
  EditRole = "edit.role",
  ViewRole = "view.role",

  //Other example
  ViewDashboard = "view.dashboard",


  //Merchant
  AddMerchant = "add.merchant",
  EditMerchant = "edit.merchant",
  ViewMerchant = "view.merchant",
  DeleteMerchant = "delete.merchant",
  ConfigureLoyaltyCommission = "loyalty.commission.configuration",

  //Merchant Configuration
  AddMerchantConfiguration = "add.merchant.configuration",
  ViewMerchantConfiguration = "view.merchant.configuration",
  EditMerchantConfiguration = "edit.merchant.configuration",
  DeleteMerchantConfiguration = "delete.merchant.configuration",

  //User Management
  AddUser = "add.user",
  EditUser = "edit.user",
  DeleteUser = "delete.user",
  ViewUser = "view.user",
  GlobalUserSearch = "global.user.search",

  //Client Management
  AddClient = "add.client",
  EditClient = "edit.client",
  ViewClient = "view.client",

  //Partcipant configuration
  AddParticipantConfiguration = "add.participant.configuration",
  ViewParticipantConfiguration = "view.participant.configuration",
  EditParticipantConfiguration = "edit.participant.configuration",

  //Terminal comfiguration
  AddTerminalConfiguration = "add.terminal.configuration",
  EditTerminalConfiguration = "edit.terminal.configuration",
  ViewTerminalConfiguration = "view.terminal.configuration",
  DeleteTerminalConfiguration = "delete.terminal.configuration",

  //Terminal
  AddTerminal = "add.terminal",
  EditTerminal = "edit.terminal",
  ViewTerminal = "view.terminal",
  DeleteTerminal = "delete.terminal",
  HasAccessToTerminalType = "edit.terminal.type",
  HasAccessToTerminalStatus = "edit.terminal.status",
  HasAccessToProductProfile = "edit.terminal.product.profile",
  HasAccessToTerminalCapability = "edit.terminal.capability",
  HasAccessToCommsProfile = "edit.terminal.comms.profile",
  HasAccessToContactLess = "edit.terminal.contactless",

  ViewUserAudit = 'view.user.audit',
  ViewRoleAudit = 'view.role.audit',

  //Terminal and Merchant Audit
  ViewTerminalAudit = 'view.terminal.audit',
  ViewMerchantAudit = 'view.merchant.audit',
  ViewTerminalConfigAudit = "view.terminal.config.audit",
  ViewMerchantConfigAudit = "view.merchant.config.audit",

  //Terminal Interaction
  AddTerminalInteraction = "add.terminal.interaction",
  EditTerminalInteraction = "edit.terminal.interaction",
  ViewTerminalInteraction = "view.terminal.interaction",


  //Manual Pan Entry
  AddManualPanEntry = "add.manualpanentry",
  EditManualPanEntry = "edit.manualpanentry",
  ViewManualPanEntry = "view.manualpanentry",

  //Settlement
  HoldSettlement = "hold.settlement",
  ReleaseSettlement = "release.settlement",
  ViewSettlement = "view.settlement",

  //Report
  ViewTutukaReport = "view.tutuka.report",
  ManageTutukaManagementReportSetups = "manage.tutuka.report.setup",
  ViewGenericReport = "view.generic.report",
  ViewGiftCardReport = "view.gift.card.report",
  ViewReconReport = "view.recon.report",
  ViewRawReport = "view.raw.report",
  ViewExceptionReport = "view.exception.report",
  ViewQrReport = "view.qr.report",

  //Credit
  ViewCredit = "view.credit",

  //Merchant sign up
  ViewMerchantSignUp = "view.merchant.signup",
  EditMerchantSignUp = "edit.merchant.signup",
  EditTerminaSignUpStaging = "edit.terminal.staging.signup",
  ViewTerminalDispatched = "view.terminal.dispatched",
  EditMerchantTerminalConfig = "edit.merchant.terminal.config",
  AddTerminalSignUpNotes = 'add.terminal.signup.notes',
  DeleteTerminalTicket = 'delete.terminal.ticket',
  GenerateRemedyCall = 'generate.remedy.call',
  ResetTerminalTicket = 'reset.terminal.ticket',
  ArchiveTerminalTicket = 'archive.terminal.ticket',
  ViewTerminalSignUpReport = 'view.terminal.signup.report',
  ViewReturnedTerminalsReport = 'view.returned.terminals.report',
}

export const PermissionEnumMapping: Record<PermissionEnum, string> = {
  [PermissionEnum.AddRole]: "Add Roles",
  [PermissionEnum.DeleteRole]: "Delete Roles",
  [PermissionEnum.EditRole]: "Edit Roles",
  [PermissionEnum.ViewRole]: "View Roles",
  [PermissionEnum.ViewDashboard]: "View Dashboard",

  [PermissionEnum.AddMerchant]: "Add Merchant",
  [PermissionEnum.EditMerchant]: "Edit Merchant",
  [PermissionEnum.ViewMerchant]: "View Merchant",
  [PermissionEnum.DeleteMerchant]: "Delete Merchant",
  [PermissionEnum.ConfigureLoyaltyCommission]: "Configure Loyalty Commission",

  [PermissionEnum.AddMerchantConfiguration]: "Add Merchant Configuration",
  [PermissionEnum.ViewMerchantConfiguration]: "View Merchant Configuration",
  [PermissionEnum.EditMerchantConfiguration]: "Edit Merchant Configuration",
  [PermissionEnum.DeleteMerchantConfiguration]: "Delete Merchant Configuration",

  [PermissionEnum.AddUser]: "Add User",
  [PermissionEnum.EditUser]: "Edit User",
  [PermissionEnum.DeleteUser]: "Delete User",
  [PermissionEnum.ViewUser]: "View User",
  [PermissionEnum.GlobalUserSearch]: "Global user search",

  [PermissionEnum.AddClient]: "Add Client",
  [PermissionEnum.EditClient]: "Edit Client",
  [PermissionEnum.ViewClient]: "View Client",

  [PermissionEnum.EditParticipantConfiguration]: "Edit Participant Configuration",
  [PermissionEnum.ViewParticipantConfiguration]: "View Participant Configuration",
  [PermissionEnum.AddParticipantConfiguration]: "Add Participant Configuration",
  [PermissionEnum.DeleteTerminalConfiguration]: "Delete Participant Configuration",

  [PermissionEnum.AddTerminalConfiguration]: "Add Terminal Configuration",
  [PermissionEnum.EditTerminalConfiguration]: "Edit Terminal Configuration",
  [PermissionEnum.ViewTerminalConfiguration]: "View Terminal Configuration",

  [PermissionEnum.AddTerminal]: "Add Terminal",
  [PermissionEnum.EditTerminal]: "Edit Terminal",
  [PermissionEnum.ViewTerminal]: "View Terminal",
  [PermissionEnum.DeleteTerminal]: "Delete Terminal",
  [PermissionEnum.HasAccessToTerminalStatus]: "Active/Deactivate Terminal",
  [PermissionEnum.HasAccessToTerminalType]: "Edit Terminal Type",
  [PermissionEnum.HasAccessToProductProfile]: "Edit Terminal Product Profile",
  [PermissionEnum.HasAccessToTerminalCapability]: "Edit Terminal Capability",
  [PermissionEnum.HasAccessToCommsProfile]: "Edit Terminal Comms Profile",
  [PermissionEnum.HasAccessToContactLess]: "Edit Terminal Contactless",

  [PermissionEnum.ViewTerminalAudit]: "View Terminal Audit",
  [PermissionEnum.ViewMerchantAudit]: "View Merchant Audit",


  [PermissionEnum.ViewTerminalConfigAudit]: "View Terminal Config Audit",
  [PermissionEnum.ViewMerchantConfigAudit]: "View Merchant Config Audit",


  [PermissionEnum.AddTerminalInteraction]: "Add Terminal Interaction",
  [PermissionEnum.EditTerminalInteraction]: "Edit Terminal Interaction",
  [PermissionEnum.ViewTerminalInteraction]: "View Terminal Interaction",

  [PermissionEnum.AddManualPanEntry]: "Add Manual Pan Entry",
  [PermissionEnum.EditManualPanEntry]: "Edit Manual Pan Entry",
  [PermissionEnum.ViewManualPanEntry]: "View Manual Pan Entry",

  [PermissionEnum.HoldSettlement]: "Hold Settlement",
  [PermissionEnum.ReleaseSettlement]: "Release Settlement",
  [PermissionEnum.ViewSettlement]: "View Settlement",

  [PermissionEnum.ViewTutukaReport]: "View Tutuka Report",
  [PermissionEnum.ManageTutukaManagementReportSetups]: "Manage Tutuka Report Management",
  [PermissionEnum.ViewGenericReport]: "View Generic Report",
  [PermissionEnum.ViewGiftCardReport]: "View Gift Card Report",
  [PermissionEnum.ViewReconReport]: "View Recon Report",
  [PermissionEnum.ViewRawReport]: "View Raw Report",
  [PermissionEnum.ViewExceptionReport]: "View Exception Report",
  [PermissionEnum.ViewQrReport]: "View QR Report",

  [PermissionEnum.ViewUserAudit]: "View User Audit Trail",
  [PermissionEnum.ViewRoleAudit]: "View Role Audit Trail",

  [PermissionEnum.ViewCredit]: "View Credit",

  [PermissionEnum.ViewMerchantSignUp]: "View Merchant Sign Up",
  [PermissionEnum.EditMerchantSignUp]: "Edit Merchant Sign Up",
  [PermissionEnum.EditTerminaSignUpStaging]: "Edit Terminal Sign Up Staging",
  [PermissionEnum.ViewTerminalDispatched]: "View Terminal Dispatched",
  [PermissionEnum.EditMerchantTerminalConfig]: "Edit Merchant Terminal Config",
  [PermissionEnum.AddTerminalSignUpNotes]: "Add Terminal SignUp Notes",
  [PermissionEnum.DeleteTerminalTicket]: "Delete Terminal Ticket",
  [PermissionEnum.GenerateRemedyCall]: "Generate Remedy Call",
  [PermissionEnum.ResetTerminalTicket]: "Reset Terminal Ticket",
  [PermissionEnum.ArchiveTerminalTicket]: "Archive Terminal Ticket",
  [PermissionEnum.ViewTerminalSignUpReport]: "View Terminal SignUp Report",
  [PermissionEnum.ViewReturnedTerminalsReport]: "View Returned Terminals Report"
};


export enum AccessPolicyEnum {
  GlobalUserSearch = "GlobalUserSearch",
  RolesManagement = "RolesManagement",
  ParticipantManagement = "ParticipantManagement",
  ViewClient = "ViewClient",
  UserManagement = "UserManagement",
  ViewMerchant = "ViewMerchant",
  DeleteMerchant = "DeleteMerchant",
  ViewMerchantConfiguration = "ViewMerchantConfiguration",
  EditMerchantConfiguration = "EditMerchantConfiguration",
  ViewTerminalConfiguration = "ViewTerminalConfiguration",
  EditTerminalConfiguration = "EditTerminalConfiguration",
  ViewTerminal = "ViewTerminal",
  EditTerminal = "EditTerminal",
  AddTerminal = "AddTerminal",
  DeleteTerminal = "DeleteTerminal",
  TerminalStatus = "ActiveDeactivateTerminal",
  TerminalType = "EditTerminalType",
  ProductProfile = "EditTerminalProductProfile",
  TerminalCapability = "EditTerminalCapability",
  CommsProfile = "EditTerminalCommsProfile",
  ContactLess = "EditTerminalContactless",

  ClientManagement = "ClientManagement",
  ViewTerminalAudit = "ViewTerminalAudit",
  ViewMerchantAudit = "ViewMerchantAudit",
  ViewMerchantConfigAudit = "ViewMerchantConfigAudit",
  ViewTerminalConfigAudit = "ViewTerminalConfigAudit",
  ViewSettlement = "ViewSettlement",
  ConfigLoyaltyCommission = "ConfigureLoyaltyCommission",
  ViewTutukaReport = "ViewTutukaReport",
  ViewCredit = "ViewCredit",
  ViewMerchantSignUp = "ViewMerchantSignUp",
  EditMerchantSignUp = "EditMerchantSignUp",
  EditTerminaSignUpStaging = "EditTerminaSignUpStaging",
  ViewTerminalDispatched = "ViewTerminalDispatched",
  EditMerchantTerminalConfig = "EditMerchantTerminalConfig",
  AddTerminalSignUpNotes = "AddTerminalSignUpNotes",
  DeleteTerminalTicket = "DeleteTerminalTicket",
  GenerateRemedyCall = "GenerateRemedyCall",
  ResetTerminalTicket = "ResetTerminalTicket",
  ArchiveTerminalTicket = "ArchiveTerminalTicket",
  ViewTerminalSignUpReport = "ViewTerminalSignUpReport",
  ManageTutukaManagementReportSetups = "ManageTutukaManagementReportSetups",
  ViewGenericReport = "ViewGenericReport",
  ViewGiftCardReport = "ViewGiftCardReport",
  ViewReconReport = "ViewReconReport",
  ViewRawReport = "ViewRawReport",
  ViewExceptionReport = "ViewExceptionReport",
  ViewQrReport = "ViewQrReport",
  ViewUserAudit = "ViewUserAudit",
  ViewRoleAudit = "ViewRoleAudit",
  ViewReturnedTerminalsReport = "ViewReturnedTerminalsReport"
}

export const DefaultAccessPolicies: Record<AccessPolicyEnum, PermissionEnum[]> = {
  [AccessPolicyEnum.RolesManagement]: [PermissionEnum.ViewRole],
  [AccessPolicyEnum.ViewClient]: [PermissionEnum.ViewClient],
  [AccessPolicyEnum.ParticipantManagement]: [PermissionEnum.ViewParticipantConfiguration],
  [AccessPolicyEnum.UserManagement]: [PermissionEnum.ViewUser, PermissionEnum.EditUser, PermissionEnum.AddUser, PermissionEnum.GlobalUserSearch],

  [AccessPolicyEnum.ViewMerchant]: [PermissionEnum.ViewMerchant],
  [AccessPolicyEnum.DeleteMerchant]: [PermissionEnum.DeleteMerchant],
  [AccessPolicyEnum.ViewTerminalConfiguration]: [PermissionEnum.ViewTerminalConfiguration],
  [AccessPolicyEnum.EditTerminalConfiguration]: [PermissionEnum.EditTerminalConfiguration],
  [AccessPolicyEnum.ViewMerchantConfiguration]: [PermissionEnum.ViewMerchantConfiguration],
  [AccessPolicyEnum.EditMerchantConfiguration]: [PermissionEnum.EditMerchantConfiguration],
  [AccessPolicyEnum.ViewTerminalAudit]: [PermissionEnum.ViewTerminalAudit],
  [AccessPolicyEnum.ViewMerchantAudit]: [PermissionEnum.ViewMerchantAudit],
  [AccessPolicyEnum.ViewUserAudit]: [PermissionEnum.ViewUserAudit],
  [AccessPolicyEnum.ViewRoleAudit]: [PermissionEnum.ViewRoleAudit],
  [AccessPolicyEnum.AddTerminal]: [PermissionEnum.AddTerminal],
  [AccessPolicyEnum.EditTerminal]: [PermissionEnum.EditTerminal],
  [AccessPolicyEnum.ViewTerminal]: [PermissionEnum.ViewTerminal],
  [AccessPolicyEnum.DeleteTerminal]: [PermissionEnum.DeleteTerminal],
  [AccessPolicyEnum.TerminalStatus]: [PermissionEnum.HasAccessToTerminalStatus],
  [AccessPolicyEnum.TerminalType]: [PermissionEnum.HasAccessToTerminalType],
  [AccessPolicyEnum.ProductProfile]: [PermissionEnum.HasAccessToProductProfile],
  [AccessPolicyEnum.TerminalCapability]: [PermissionEnum.HasAccessToTerminalCapability],
  [AccessPolicyEnum.CommsProfile]: [PermissionEnum.HasAccessToCommsProfile],
  [AccessPolicyEnum.ContactLess]: [PermissionEnum.HasAccessToContactLess],
  [AccessPolicyEnum.ClientManagement]: [PermissionEnum.ViewClient],
  [AccessPolicyEnum.ViewMerchantConfigAudit]: [PermissionEnum.ViewMerchantConfigAudit],
  [AccessPolicyEnum.ViewTerminalConfigAudit]: [PermissionEnum.ViewTerminalConfigAudit],
  [AccessPolicyEnum.ViewSettlement]: [PermissionEnum.ViewSettlement],
  [AccessPolicyEnum.ConfigLoyaltyCommission]: [PermissionEnum.ConfigureLoyaltyCommission],
  [AccessPolicyEnum.GlobalUserSearch]: [PermissionEnum.GlobalUserSearch],
  [AccessPolicyEnum.ViewTutukaReport]: [PermissionEnum.ViewTutukaReport],
  [AccessPolicyEnum.ViewCredit]: [PermissionEnum.ViewCredit],
  [AccessPolicyEnum.ViewMerchantSignUp]: [PermissionEnum.ViewMerchantSignUp],
  [AccessPolicyEnum.EditMerchantSignUp]: [PermissionEnum.EditMerchantSignUp],
  [AccessPolicyEnum.EditTerminaSignUpStaging]: [PermissionEnum.EditTerminaSignUpStaging],
  [AccessPolicyEnum.ViewTerminalDispatched]: [PermissionEnum.ViewTerminalDispatched],
  [AccessPolicyEnum.EditMerchantTerminalConfig]: [PermissionEnum.EditMerchantTerminalConfig],
  [AccessPolicyEnum.AddTerminalSignUpNotes]: [PermissionEnum.AddTerminalSignUpNotes],
  [AccessPolicyEnum.DeleteTerminalTicket]: [PermissionEnum.DeleteTerminalTicket],
  [AccessPolicyEnum.GenerateRemedyCall]: [PermissionEnum.GenerateRemedyCall],
  [AccessPolicyEnum.ResetTerminalTicket]: [PermissionEnum.ResetTerminalTicket],
  [AccessPolicyEnum.ArchiveTerminalTicket]: [PermissionEnum.ArchiveTerminalTicket],
  [AccessPolicyEnum.ViewTerminalSignUpReport]: [PermissionEnum.ViewTerminalSignUpReport],
  [AccessPolicyEnum.ManageTutukaManagementReportSetups]: [PermissionEnum.ManageTutukaManagementReportSetups],
  [AccessPolicyEnum.ViewGenericReport]: [PermissionEnum.ViewGenericReport],
  [AccessPolicyEnum.ViewGiftCardReport]: [PermissionEnum.ViewGiftCardReport],
  [AccessPolicyEnum.ViewReconReport]: [PermissionEnum.ViewReconReport],
  [AccessPolicyEnum.ViewRawReport]: [PermissionEnum.ViewRawReport],
  [AccessPolicyEnum.ViewExceptionReport]: [PermissionEnum.ViewExceptionReport],
  [AccessPolicyEnum.ViewQrReport]: [PermissionEnum.ViewQrReport],
  [AccessPolicyEnum.ViewReturnedTerminalsReport]: [PermissionEnum.ViewReturnedTerminalsReport]
};


